import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { storageKey } from "app/utils/storageKeys";
import { RequestQuoteData } from "app/api/quote/quote.types";

const isQuoteOpen = atom(false);
const quotesList = atomWithStorage<RequestQuoteData[]>(storageKey.requestQuote, []);

export { isQuoteOpen, quotesList };
